import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const SMALL_LOGO_WIDTH = 64;
export const LARGE_LOGO_WIDTH = 264;

export const TeamStatsContainer = styled.div`
    background: ${({ theme }) => theme.Surface.disabled};
    border: solid 1px ${({ theme }) => theme.Surface.border};
    border-radius: 8px;
    display: flex;
    height: 64px;
    padding: 0 8px;
    place-content: center;
`;

export const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    min-width: ${SMALL_LOGO_WIDTH}px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        min-width: ${LARGE_LOGO_WIDTH}px;
    }

    img {
        height: 36px;
        width: 54px;

        ${BaseStyle.Mixins.screenSizes.medium} {
            height: 48px;
            width: 72px;
        }
    }
`;
